import.meta.glob(['../images/**', '../fonts/**']);
import alpine from 'alpinejs';
import Lenis from 'lenis';
import { homeCarousel } from './blocks/home-carousel';
import { expandingImage } from './blocks/expanding-image';
import { productOverview } from './blocks/product-overview';
import { contentSingleProduct } from './partials/content-single-product';
import { sampleServiceForm } from './blocks/sample-service-form';
import { orderForm } from './blocks/order-form';
import { showroomVisitForm } from './blocks/showroom-visit-form';

Object.assign(window, { Alpine: alpine }).Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
  // Smooth scrolling
  new Lenis({
    autoRaf: true,
  });

  // Selectors and their corresponding init functions
  const selectors = {
    '.wp-block-home-carousel': homeCarousel,
    '.wp-block-expanding-image': expandingImage,
    '.wp-block-product-overview': productOverview,
    '.wp-block-sample-service-form': sampleServiceForm,
    '.wp-block-showroom-visit-form': showroomVisitForm,
    '.wp-block-order-form': orderForm,
    'body.single-product': contentSingleProduct,
  };

  // Loop through selectors and initialize those that exist in the DOM
  Object.entries(selectors).forEach(([selector, initFunction]) => {
    if (document.querySelector(selector)) {
      initFunction();
    }
  });
});
